import i18n from 'i18next';
import { ApiError } from '@/api/client';

/** Human, translated message for any thrown error. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'NETWORK') return i18n.t('errors.network');
    const key = `errors.${err.code}`;
    return i18n.exists(key) ? i18n.t(key) : err.message || i18n.t('errors.generic');
  }
  return i18n.t('errors.generic');
}

/** Translated per-field messages from a 422 response. */
export function fieldErrors(err: unknown): Record<string, string> {
  if (!(err instanceof ApiError)) return {};
  return Object.fromEntries(
    Object.entries(err.fields).map(([field, code]) => [
      field,
      i18n.exists(`validation.${code}`) ? i18n.t(`validation.${code}`) : code,
    ]),
  );
}
